import { render, staticRenderFns } from "./OAuthExchange.vue?vue&type=template&id=437f4c41"
import script from "./OAuthExchange.vue?vue&type=script&lang=js"
export * from "./OAuthExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports